import CarouselNewsSection from "../../Component/CarouselNewsSection";

import SectionOne from "../../Component/Sectionone";
import Sectiontwo from "../../Component/Sectiontwo";

function Home() {

  return (
    <div>
      <CarouselNewsSection />
      <SectionOne />
      <Sectiontwo />
    </div>
  );
}

export default Home;
